import { useState } from 'react';
import * as Yup from 'yup';

/**
 * useYupValidationカスタムフック
 * 
 * @param {Yup.ObjectSchema} schema - Yupスキーマを使用してフォームのバリデーションを行う。
 * @returns {Object} - エラーオブジェクト、タッチオブジェクト、handleValidate関数、およびhandleTouch関数を含むオブジェクト。
 */
const useYupValidation = (schema,preCheck) => {
  // エラーオブジェクトの状態を管理
  const [errors, setErrors] = useState({});

  // タッチされたフィールドを追跡
  const [touched, setTouched] = useState({});

  /**
   * handleValidate関数
   * 
   * フォームデータを検証し、エラーを更新する。
   * @param {Object} formData - 検証するフォームデータ。
   */
  const handleValidate = (formData, isCheckTouch = true) => {
    const instantiateErr = preCheck? preCheck(formData) : {}
    try {
      // Validate the form data using the Yup schema synchronously
      schema.validateSync(formData, { abortEarly: false });
      setErrors(instantiateErr); // Clear error object if no errors are found
      return instantiateErr;
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        // Collect errors and set them on touched fields
        const errs = error.inner.reduce((acc, curr) => {
          // For each error, check if the field was touched or if touch check is disabled
          const path = curr.path || ''; // Ensure path is a string to avoid errors
          if (touched[path] || !isCheckTouch) {
            acc[path] = curr.message;
          }
          return acc;
        }, {});

        const resErr = {...instantiateErr,...errs};
        setErrors(resErr); // Update state or context with the collected errors
        return resErr;
      }
    }
  };
  

  /**
   * handleTouch関数
   * 
   * フィールドがタッチされたことを記録する。
   * @param {string} fieldName - タッチされたフィールドの名前。
   */
  const handleTouch = (fieldName) => {
    setTouched(prev => ({ ...prev, [fieldName]: true }));
  };
  
  /**
   * setCustomError関数
   *
   * カスタムエラーを手動で設定する関数。
   * @param {string} fieldName - エラーを設定するフィールド名。
   * @param {string} errorMessage - フィールドに関連するエラーメッセージ。
   */
  const setCustomError = (fieldName, errorMessage) => {
    setErrors((prev) => ({ ...prev, [fieldName]: errorMessage }));
  };

  return {
    errors,
    touched,
    handleValidate,
    handleTouch,
    setCustomError
  };
};

export default useYupValidation;
